export const environment = {
  production: true,
  environmentName: 'production',
  apiUrl: 'https://api.dynamicmanaging.com/',
};
